module.exports = __webpack_public_path__ + "media/src/assets/boatdriver-0567f9b6a5249846941b536fd21ffc7e.png";